module.exports = __webpack_public_path__ + "static/media/p21.b0cc2a6e.jpeg";